// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// "lite" = plain one-off HTTPS requests. The full SDK keeps a streaming
// (WebChannel) connection open, which some browsers/networks can't establish
// ("Could not reach Cloud Firestore backend"), leaving the shop empty. The site
// only reads products and adds form entries, which lite does fine.
import { getFirestore } from "firebase/firestore/lite";
import { getStripePayments } from "@invertase/firestore-stripe-payments";
import { getProducts } from "@invertase/firestore-stripe-payments";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// NOTE: measurementId / Firebase Analytics is intentionally NOT initialized
// here. GA4 is loaded directly via gtag.js in public/index.html so we can
// implement Consent Mode v2 and the cross-domain linker. Initializing
// Firebase Analytics here would duplicate the GA4 loader.
const firebaseConfig = {
  apiKey: "AIzaSyAk3Qzc4kmfiWoUtiIV-xQUyk9bdncLNxo",
  authDomain: "cork-matters-d293d.firebaseapp.com",
  projectId: "cork-matters-d293d",
  storageBucket: "cork-matters-d293d.appspot.com",
  messagingSenderId: "898850031142",
  appId: "1:898850031142:web:43d91fed5f2020dbffc8e7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const payments = getStripePayments(app, {
  customersCollection: "customers",
});
export const auth = getAuth(app);
export const storage = getStorage(app);

// const products = await getProducts(payments, {
//   includePrices: true,
//   activeOnly: true,
// });
